/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { DashboardDto } from '../models/dashboard-dto';

@Injectable({
  providedIn: 'root',
})
export class GeneratedDashboardService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getDashboard
   */
  static readonly GetDashboardPath = '/api/dashboard';

  /**
   * Gets dashboard information.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getDashboard()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDashboard$Response(params?: {
    'X-API-Version'?: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<DashboardDto>> {

    const rb = new RequestBuilder(this.rootUrl, GeneratedDashboardService.GetDashboardPath, 'get');
    if (params) {
      rb.header('X-API-Version', params['X-API-Version'], {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<DashboardDto>;
      })
    );
  }

  /**
   * Gets dashboard information.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getDashboard$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getDashboard(params?: {
    'X-API-Version'?: string;
  },
  context?: HttpContext

): Observable<DashboardDto> {

    return this.getDashboard$Response(params,context).pipe(
      map((r: StrictHttpResponse<DashboardDto>) => r.body as DashboardDto)
    );
  }

}
